import { render, staticRenderFns } from "./ExamResults.vue?vue&type=template&id=515d1b0a&scoped=true&"
import script from "./ExamResults.vue?vue&type=script&lang=js&"
export * from "./ExamResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d1b0a",
  null
  
)

export default component.exports